export const logsOptions = {
  all: "all",
  pass: "succeeded",
  fail: "failed",
};
